import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import LearningCorner from "../components/LearningCorner/learningCorner";
import ProfileSection from "../components/Profile/ProfileSection/profileSection";
import LiveTestDashboardSection from "../components/LiveTest/LiveTestDashboardSection";
import ExamsBoard from "../components/ExamSection/ExamsBoard";
import NextQuizListWidget from "../components/QuizList/NextQuizListWidget";
import "./icomoon-examsbook-fonts.css";
import useAnalyticsPageView from "examsbook-react-sdk/custom-hooks/useAnalyticsPageView";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import TestTypeCard from "../components/AllTestTab/TestTypeCard";
import { AppBar, Button } from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CTabs from "../components/Tabs/CTabs";
import AllDashboardContainer from "../components/Tabs/AllDashboardContainer";
import useSubExamList from "examsbook-react-sdk/custom-hooks/useSubExamList";
import DashboardIcon from "@material-ui/icons/Dashboard";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import DashboradEmptyImage from "../components/common/loaders/DashboardImageLoader";
import SimpleImageSlider from "react-simple-image-slider";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import usePromotions from "examsbook-react-sdk/custom-hooks/usePromotions";
import {
  useIsPremiumUser,
  useMinPlanPrice,
} from "examsbook-react-sdk/custom-hooks";
import useUserLanguage from "examsbook-react-sdk/custom-hooks/useUserLanguage";
import { useNavigate } from "react-router-dom";
import ExamsBookHeaderLogo from "../assets/images/examsbook-logo.png";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
});

/**
 * Main dashboard page
 */

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: true,
  slidesToShow: 1,
  pauseOnHover: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
};
function Dashboard(props) {
  //google analytics
  useAnalyticsPageView();
  const subExamList = useSubExamList();
  const navigate = useNavigate();
  const t = useTranslations();
  const [selectedTab, setSelectedTab] = useState(0);
  const isVip = useIsPremiumUser();
  const { language } = useUserLanguage();
  const { promotionsBanners, pending } = usePromotions(
    isVip,
    language,
    window.location.origin
  );
  let bannerImages = promotionsBanners
    ? promotionsBanners.map((data) => ({ url: data.image }))
    : [];
  let bannerActions =
    promotionsBanners && promotionsBanners.map((data) => data.action);
  const minPrice = useMinPlanPrice();
  const appSettings = useSelector((state) => state.appSettings);
  const isPaymentEnabled = !!appSettings.paymentEnabled;
  function handleTabChange(event, value) {
    setSelectedTab(value);
  }

  let tabBarList = [
    {
      label: t("dashboard"),
      ref: "dashboard",
      icon: <DashboardIcon />,
    },
    {
      label: t("all_test"),
      ref: "all",
      icon: <AssignmentIcon />,
    },
    {
      label: t("test_series"),
      ref: "mytest",
      icon: <MenuBookIcon />,
    },
    {
      label: t("practice"),
      ref: "practice",
      icon: <i className="fa fa-clock-o  m-r-18 fa-2x" aria-hidden="true" />,
    },
  ];

  const clickOnSliderImage = (index) => {
    if (isPaymentEnabled) {
      const actionType =
        bannerActions &&
        bannerActions[index] &&
        bannerActions[index].actionType;
      const objId =
        bannerActions && bannerActions[index] && bannerActions[index].objId;
      if (actionType === "PAYMENT") {
        navigate("/my-app/payments");
      } else if (actionType === "TEST_SERIES") {
        navigate("/my-app/test-series/" + objId + "/tests");
      } else if (actionType === "ALL_TEST_SERIES") {
        navigate("/my-app/test-series");
      }
    }
  };

  const gotoPaymentScreen = () => {
    navigate("/my-app/payments");
  };
  const _renderPromotionBanners = (items) => {
    return items.map((item, index) => {
      return (
        <div className="banner-box" key={index}>
          <img
            style={{ width: "100%" }}
            src={item.url}
            alt={item.url}
            className="mobile-image-home-banner"
          />
        </div>
      );
    });
  };

  const ImageSlider = () => {
    return (
      <div>
        {bannerImages && bannerImages.length > 0 && (
          <div className="mobile-image-slider">
            <Slider {...settings}>
              {_renderPromotionBanners(bannerImages || [])}
            </Slider>
            {/* <SimpleImageSlider
                key={new Date().getTime}
                onClick={clickOnSliderImage}
                images={bannerImages}
                showBullets={
                  bannerImages && bannerImages.length > 1 ? true : false
                }
                // loop
                showNavs={false}
                width="100%"
                height={200}
                bgColor="#fff"
                // autoPlay
                slideDuration={0.9}
              /> */}
          </div>
        )}
      </div>
    );
  };

  function BuyPlanBanner() {
    return (
      <>
        <div className="buy-pass-header">
          <img src={ExamsBookHeaderLogo} alt="" />
          <span>Unlock 2000+ Mock Tests and 40000+ Questions</span>
        </div>
        <div className="buy-pass-footer">
          <div className="buy-pass-rate">
            <span>Starts from</span>
            <p>₹ {minPrice}/Month</p>
          </div>
          <Button onClick={gotoPaymentScreen}>{t("BUY_PASS")}</Button>
        </div>
      </>
    );
  }

  return (
    <div>
      {selectedTab === 0 ? (
        <>
          <a
            href="https://play.google.com/store/apps/details?id=com.examsbook.myapp"
            className="downloadApp"
          >
            {t("Download Mobile App")}
          </a>
          <div className="dashboard-container">
            <div className="dashboard-left">
              {!pending ? ImageSlider() : <DashboradEmptyImage />}
              <div className="web-test-dashboard">
                <LiveTestDashboardSection />
              </div>
              <div>
                <TestTypeCard />
              </div>
              {!isVip && isPaymentEnabled && (
                <div className="buy-pass-card mobile-learning-corner">
                  <BuyPlanBanner />
                </div>
              )}
              <ExamsBoard />
              <div className="mobile-test-dashboard">
                <LiveTestDashboardSection />
              </div>
              <NextQuizListWidget />
              <div className="mobile-learning-corner">
                <LearningCorner t={t} />
              </div>
            </div>
            <div className="dashboard-right">
              <div className="exam-board profile-board">
                <div className="exam-heading"></div>
                <ProfileSection />
              </div>
              {isPaymentEnabled && (
                <div className="buy-pass-card web-learning-corner">
                  <BuyPlanBanner />
                </div>
              )}
              <div className="web-learning-corner">
                <LearningCorner t={t} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <AllDashboardContainer
          selectedIndex={selectedTab}
          handleTabChange={handleTabChange}
          subExamList={subExamList.category}
        />
      )}
      <div className="dashboard-mobile-view">
        <div className={"mock-tabs"}>
          <AppBar position="static" className="tabs">
            <CTabs
              nav={tabBarList}
              setActiveTab={selectedTab}
              handleTabChange={handleTabChange}
            />
          </AppBar>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(Dashboard);
